import React from "react";
import { Grid, Box, Typography, TextareaAutosize } from "@mui/material";
import { tokens } from "../../Common/designTokens";

const rejectReasonTextAreaStyle = {
  width: "100%",
  minHeight: "32px",
  padding: "8px",
  boxSizing: "border-box",
  border: `1px solid ${tokens.colors.bodyBorderColor50}`,
  borderRadius: "8px",
  backgroundColor: tokens.colors.defaultGridRowColor,
  color: tokens.colors.disabledFontColour,
  resize: "vertical",
  fontFamily: "inherit",
  fontSize: "inherit",
  wordWrap: "break-word",
  whiteSpace: "pre-wrap",
  overflowX: "hidden",
  lineHeight: "32px",
  opacity: 0.95,
//   cursor: "not-allowed",
  "&:disabled": {
    opacity: 0.95,
    backgroundColor: tokens.colors.defaultGridRowColor,
    cursor: "not-allowed",
    color: tokens.colors.disabledFontColour,
  },
};

const RejectReason = ({ rejectReason }) => {
  // Only render if rejectReason exists and is not null/undefined
  if (!rejectReason) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Typography
          variant="subtitle2"
          sx={{
            mb: 0.5,
            color: tokens.colors.fontColour,
            fontWeight: 600,
          }}
        >
          Reject Reason
        </Typography>
        <TextareaAutosize
          name="rejectReason"
          value={rejectReason || ""}
          disabled
          minRows={1}
          maxRows={5}
          style={{
            ...rejectReasonTextAreaStyle,
            outline: 'none',
            boxShadow: 'none',
            WebkitBoxShadow: 'none',
            height: "46px",
            minHeight: "46px",
            resize: "none",
          }}
        />
      </Box>
    </Grid>
  );
};

export default RejectReason;
